
// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// init Swiper:
const swiper = new Swiper('.js_main_slider', {
  // configure Swiper to use modules
  modules: [Autoplay, Navigation, Pagination],

  loop: true,
  grabCursor: true,
  draggable: true,
  slidesPerView: 1,
  autoHeight: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  lazy: true,

  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 1,
  },

  autoplay: {
    delay: 6000,
    disableOnInteraction: false
  },
});